const routes = [{
  path: '/policy',
  component: () => import('@/views/policy'),
  name: 'policy',
  meta: {
    title: '政策管理/我的政策'
  }
}, {
  path: '/policy/documentary',
  component: () => import('@/views/policy/documentary'),
  name: 'policy-documentary',
  meta: {
    title: '跟单政策'
  }
}, {
  path: '/policy/list',
  component: () => import('@/views/policy/list'),
  name: 'policy-list',
  meta: {
    title: '保险政策'
  }
}, {
  path: '/policy/approval',
  component: () => import('@/views/policy/approval'),
  name: 'policy-approval',
  meta: {
    title: '政策审批'
  }
}, {
  path: '/policy/setting',
  component: () => import('@/views/policy/config'),
  name: 'policy-setting',
  meta: {
    title: '留点设置'
  }
}, {
  path: '/policy/history',
  component: () => import('@/views/policy/history'),
  name: 'policy-history',
  meta: {
    title: '留点设置/历史记录'
  }
}, {
  path: '/policy/edit',
  component: () => import('@/views/policy/edit'),
  name: 'policy-edit',
  meta: {
    title: '编辑'
  }
}, {
  path: '/policy/marketing',
  component: () => import('@/views/policy/marketingProgram'),
  name: 'marketing-program',
  meta: {
    title: '数字营销方案'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/policy.js